(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pp-lickable-waitlist"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.ppw-form').forEach(function(form){
  form.addEventListener('submit',function(){
    if(!form.checkValidity())return;
    var button=form.querySelector('button[type="submit"]');
    if(!button)return;
    button.dataset.original=button.innerHTML;
    button.textContent=button.dataset.loading;
    button.setAttribute('aria-busy','true');
    setTimeout(function(){button.disabled=true;},0);
  });
});
window.addEventListener('pageshow',function(){document.querySelectorAll('.ppw-form button[data-original]').forEach(function(button){button.disabled=false;button.innerHTML=button.dataset.original;button.removeAttribute('aria-busy');});});

  } catch(e) { console.error(e); }
})();
})();
